import React, { useState, useEffect } from "react";

import { pageTitle } from "../PageTitle";

import BreadCrumb from "../BreadCrumb";

import HeaderOne from "../Header/HeaderOne";

import FooterOne from "../Footer/FooterOne";

import { Link, useLocation } from "react-router-dom";

import two from "../../assets/images/resource/man.png";
import { Helmet } from "react-helmet-async";
import service from "../../assets/images/resource/ML (2).jpg";

import basebg from "../../assets/images/resource/base.png";
import g1 from "../../assets/images/resource/ML-new.png";
import { launchFireworks } from "../../Pages/Courses/firework";
import { Typewriter } from 'react-simple-typewriter'
import MatrixBackground from './MatrixBackground';
import ParticleNetwork from "./ParticleNetwork";

const MachineLearning = () => {
  pageTitle("Cloudera CML Course");
  // launchFireworks();

//   const TypingText = () => (
//   <h2 style={{ color: '#00ff99', fontFamily: 'monospace' }}>
//     <Typewriter
//       words={['Deploying ML Model...', 'Monitoring Drift...', 'Scaling GPUs...']}
//       loop={0}
//       cursor
//       cursorStyle='_'
//       typeSpeed={70}
//       deleteSpeed={50}
//       delaySpeed={1000}
//     />
//   </h2>
// );
  const [showParticles, setShowParticles] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowParticles(false);
    }, 5000); // 5 seconds

    return () => clearTimeout(timer);
  }, []);

  const [formData, setFormData] = useState({
    name: "",

    email: "",

    subject: "",

    phone: "",

    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Form submitted:", formData);
    

    setFormData({
      name: "",

      email: "",

      subject: "",

      phone: "",

      message: "",
    });
  };

  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const servicesData = [
    { id: 1, title: "AI & RPA", slug: "/rpa-training" },
    { id: 2, title: "Python & SQL", slug: "/python" },
    { id: 3, title: "Data Science With Python", slug: "/cloud" },
    {
      id: 4,
      title: "Cloudera Data Engineering",
      slug: "/data-engineering-course",
    },
    { id: 5, title: "Cloudera Machine Learning", slug: "/machine-learning" },
    { id: 6, title: "Cloudera AI", slug: "/AI" },
    { id: 7, title: "Cloudera Data analyst", slug: "/data-analyst" },
  ];

  const courseDetails = [
    {
      number: 1,
      title: "Introduction to CML, AMPs and the Workbench",
      topics: "Overview, CML Versus CDSW, ML Workspaces, Workspace Roles, Projects and Teams, Settings, Runtimes/Legacy Engines.Editors and IDE, Git, Embedded Web Applications, AMPs, Data Access and Lineage.",
      youtubeShort: "#"
    },
    {
      number: 2,
      title: "Data Visualization in CML",
      topics: "Data Visualization Overview, CDP Data Visualization  Concepts, Experiments in CML, Introduction to the CML Native Workbench.",
      youtubeShort: "#"
    },
    {
      number: 3,
      title: "Spark Overview",
      topics: "How Spark Works, The Spark Stack, File Formats in Spark, Spark Interface Languages, Introduction to PySpark, How Data Frame Operations Become Spark Jobs, How Spark Executes a Job.",
      youtubeShort: "https://youtu.be/t2Eso5ZP3bM?si=vLoj8wKHIuutxkds"
    },
    {
      number: 4,
      title: "Running a Spark Application",
      topics: "Running a Spark Application, reading data into a Spark SQL Data Frame, Examining the Schema of a Data Frame, Computing the Number of Rows and Columns of a Data Frame, examining a Few Rows of a Data Frame, Stopping a Spark Application.",
      youtubeShort: "https://youtu.be/0Xj9HRMOmX0?si=L3N0tanNUGIQBcPs"
    },
    {
      number: 5,
      title: "Inspecting and Transforming a Spark Data Frame",
      topics: "Inspecting a Data Frame & Data Frame Column. Spark SQL Data Frames, Working with Columns, Working with Rows, Working with Missing Values.",
      youtubeShort: "https://youtu.be/q9loNQSgbPs?si=AlEObRdJ7OxoUh9S"
    },
    {
      number: 6,
      title: "Transforming Spark Data Frame Columns",
      topics: "Spark SQL Data Types, Working with Numerical Columns, Working with String Columns, Working with Date and Timestamp Columns, Working with Boolean Columns, Spark Complex Types and UDF.",
      youtubeShort: "https://youtu.be/_WwnxJOobq4?si=c7LdhyDSno3IXtWs"
    },
    {
      number: 7,
      title: "Spark Reading and Writing Data Frames",
      topics: "Working with Delimited Text Files, Working with Text Files, Working with Parquet Files, Working with Hive Tables, Working with Object Stores, Working with Pandas Data Frames.",
      youtubeShort: "https://youtu.be/1ELI4ZQESoY?si=J0iZqktoywkiw1Gm"
    },
    {
      number: 8,
      title: "Combining, Joining and Splitting Spark Data Frames",
      topics: "Combining and Splitting Data Frames Joining Data Frames, Splitting a Data Frame.",
      youtubeShort: "https://youtu.be/DReYGovaKEM?si=NJ8pv8eHouGZqKZn"
    },
    {
      number: 9,
      title: "Summarizing, Grouping  Data Frames and Window Functions",
      topics: "Summarizing Data with Aggregate Functions, Grouping Data, Pivoting Data & Window Functions",
      youtubeShort: "#"
    },
    {
      number: 10,
      title: "Machine Learning Overview",
      topics: "Introduction to Machine Learning, Machine Learning Tools, Apache Spark MLlib. Exploring and Visualizing Data Frames Possible Workflows for Big Data, Exploring a Single Variable, Exploring a Pair of Variables. Monitoring, Tuning, and Configuring Spark Applications",
      youtubeShort: "#"
    },
    {
      number: 11,
      title: "Fitting and Evaluating Linear Regression (Supervised) Models",
      topics: "Building Linear and Isotonic Regression models using Cloudera Machine Learning to Predictions estimate ride time based on distance.",
      youtubeShort: "https://www.youtube.com/shorts/u4t6MRLGx-8"
    },
    {
      number: 12,
      title: "Data Preprocessing, Handling Categorical Data (Supervised) with RFormula",
      topics: "How to efficiently transform string features into numeric using RFormula in Cloudera Machine Learning.",
      youtubeShort: "https://www.youtube.com/shorts/eiZaGI3hGBg"
    },
    {
      number: 13,
      title: "Fitting and Evaluating Logistic Regression (Supervised) Classification Model",
      topics: " Building Logistic Regression, a model to predict whether a ride will receive a top rating based on review presence, vehicle year, and color!",
      youtubeShort: "https://www.youtube.com/shorts/7qTZE5Is2kc"
    },
    {
      number: 14,
      title: "Tuning Algorithm Hyperparameters Using Lasso Regression (Supervised)",
      topics: "Optimizing the Ride Rating Prediction Model. How Lasso Regression + Hyperparameter Tuning help us predict rider satisfaction with high accuracy. We use Spark MLlib to test different combinations of regularization (regParam) and ElasticNet parameters to minimize error (RMSE).",
      youtubeShort: "https://www.youtube.com/shorts/Q8B6RLDWr6c"
    },
    {
      number: 15,
      title: "Fitting and Evaluating GMM (Unsupervised) Clustering Model",
      topics: "Building Gaussian Mixture Model (GMM) to group student riders based on their home locations (latitude & longitude) in Fargo, North Dakota. This clustering helps uncover hidden patterns in rider behavior — like how different student groups are geographically distributed — and can lead to smarter decisions for ride dispatch, pooling, and service optimization! 📊🌍",
      youtubeShort: "https://www.youtube.com/shorts/Lcindr4XHu4"
    },
    {
      number: 16,
      title: "Fitting and Evaluating K-Means (Unsupervised) Clustering Model",
      topics: "Building K-Means cluster model to finds structure in messy data so decisions can be smarter, faster, and more targeted. cluster ride data based on origin and destination — revealing the story hidden in the rides.",
      youtubeShort: "https://www.youtube.com/shorts/yZB_eztHA6g"
    },
    {
      number: 17,
      title: "Fitting and Evaluating Topic (Unsupervised) Model",
      topics: "Building a Topic Modeling with LDA (Latent Dirichlet Allocation) to uncover hidden themes in ride-sharing feedback from helpful drivers to delays in traffic, each topic reveals what matters most to our customers. This turns words into insights. 📊 💬🚗",
      youtubeShort: "https://www.youtube.com/shorts/eT5JHsST4t0"
    },
    {
      number: 18,
      title: "Fitting and Evaluating Random Forest (Supervised) Classification Model",
      topics: "Building a complete ML pipeline using PySpark to clean data, filter cancelled rides, and apply a Random Forest Classifier 🌳 to predict rider ratings with high accuracy and insights into which factors influence rider satisfaction the most.",
      youtubeShort: "https://www.youtube.com/shorts/bLNK_R4jiqc"
    },
    {
      number: 19,
      title: "Working with Machine Learning Pipelines (Supervised)",
      topics: "Build a Scikit-Learn Model, Apply the Model Using a Spark UDF. Models that analyze your ride distance and predict duration! By combining big data tools like Spark with powerful Python models, companies make your rides smoother and ETAs more reliable.",
      youtubeShort: "https://www.youtube.com/shorts/-UF7PIac5eM"
    },
    {
      number: 20,
      title: "Deploying a Machine Learning (Supervised) Model as a REST API in CML",
      topics: "Real-Time Ride Duration Prediction 🚗💨. ML model deployed online, users get fast and accurate ride duration estimates just by entering the distance. No more guessing, just smooth rides ahead!",
      youtubeShort: "https://www.youtube.com/shorts/ll-bgneq550"
    }
  ];


  const renderServices = () => {
    return servicesData.map((service) => (
      <li
        key={service.id}
        className={service.slug === "/Machine-Learning" ? "active" : ""}
      >
        <Link to={service.slug}>{service.title}</Link>
      </li>
    ));
  };

    const getYouTubeVideoId = (url) => {
    const parts = url.split("/");
    let id = parts[parts.length - 1];
    // Remove query parameters if present
    if (id.includes("?")) {
      id = id.split("?")[0];
    }
    return id;
  };
  const featuredYoutubeLink = "https://youtu.be/h-9d4FjmXgg?si=Kmw2R0enS_nDxAhd";
  const featuredVideoId = getYouTubeVideoId(featuredYoutubeLink);
  const featuredEmbedUrl = `https://www.youtube.com/embed/${featuredVideoId}`;

  return (
    <>
      <Helmet>
        <title>Cloudera CML Course - Learn ML with CML</title>
        <meta
          name="description"
          content="Learn machine learning using Cloudera (CML) platform. This course teaches you how to build, deploy, and manage ML models using CML."
        />
        <meta
          name="keywords"
          content="Cloudera, Machine Learning, CML, Data Science, ML Course, Learn Machine Learning"
        />
        <meta
          property="og:title"
          content="Cloudera CML Course - Learn ML with CML"
        />
        <meta
          property="og:description"
          content="Learn machine learning using Cloudera (CML) platform. This course teaches you how to build, deploy, and manage ML models using CML."
        />
        <meta property="og:image" content={service} />
        <meta property="og:url" content="http://siw.sg/machine-learning" />
      </Helmet>
      <HeaderOne />
      {/* <button onClick={launchFireworks} style={{ margin: "20px", padding: "10px" }}>
        Celebrate with Fireworks 🎉
      </button> */}
      {/* <TypingText /> */}
      {/* <MatrixBackground /> */}
      {/* {showParticles && <ParticleNetwork />} */}


      <section className="page__title p_relative">
        <div
          className="bg-layer"
          style={{ backgroundImage: `url(${g1})` }}
        ></div>
        <div className="auto-container">
          <div className="content__box p_relative">
            {/* <ul className="bread__crumb">
                    <li><Link to="/">Home</Link></li>
                    {pathnames.map((name, index) => (
                    <li key={index}>
                        <span> -</span>
                        <Link to={`/${pathnames.slice(0, index + 1).join('/')}`}>{name}</Link>
                    </li>
                    ))}
                </ul> */}
            {/* <h1 className="title">{pathnames.length > 0 ? pathnames[pathnames.length - 1] : 'Home'}</h1> */}
          </div>
        </div>
      </section>

      <div className="service__details p_relative">
        <div className="auto-container">
          <div className="row">
            <div className="col-xl-8 col-lg-12 col-md-12">
              <div className="service__right">
                <figure>
                  <img src={service} alt="Service" />
                </figure>

                <h2>
                  <span>About This Training</span>
                </h2>

                <p>
                  Enterprise data science teams need collaborative access to business data, 
                  tools, and computing resources required to develop and deploy machine 
                  learning workflows.  Cloudera ( CML), part of the Cloudera 
                  Data Platform (CDP), provides the solution, giving data science teams the 
                  required resources.
                </p>

                <p>
                  This four-day course covers machine learning workflows and operations 
                  using  CML. Participants explore, visualize, and analyze data. You will also 
                  train, evaluate, and deploy machine learning models. 
                </p>

                <p>
                  The course walks through an end-to-end data science and machine learning 
                  workflow based on realistic scenarios and datasets from a fictitious 
                  technology company. The demonstrations and exercises are conducted in 
                  Python (with PySpark) using  CML.
                </p>

                <h3>
                  <span>What Skills You Will Gain</span>
                </h3>

                <ul style={{ marginBottom: "15px", lineHeight: "1.0" }}>
                  <li>Utilize Cloudera SDX and other components of the Cloudera Data Platform to locate data for machine learning experiments</li>
                  <li> Use an Applied ML Prototype (AMP)</li>
                  <li> Manage machine learning experiments</li>
                  <li> Connect to various data sources and explore data</li>
                  <li> Utilize Apache Spark and Spark ML</li>
                  <li> Deploy an ML model as a REST API</li>
                  <li>Manage and monitor deployed ML models</li>
                </ul>
                <h3>
                  <span>Who Should Take This Course?</span>
                </h3>
                  <p>
                  The course is designed for data scientists who need to understand how to 
                  utilize  Cloudera CML and the Cloudera Data Platform to 
                  achieve faster model development and deliver production machine learning
                  at scale. Data engineers, developers, and solution architects who 
                  collaborate with data scientists will also find this course valuable.
                  </p>

                <h3>
                  <span>Course Details</span>
                </h3>
                <ul className="course-details-list" style={{ listStyle: "none", padding: 0 }}>
                  {courseDetails.map((item) => {
                    const videoId = getYouTubeVideoId(item.youtubeShort);
                    const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                    return (
                      <li
                        key={item.number}
                        className="course-detail-item"
                        style={{
                          display: "flex",
                          alignItems: "start",
                          marginBottom: "20px",
                          background: "#f9f9f9",
                          padding: "15px",
                          borderRadius: "8px",
                        }}
                      >
                        <div style={{ flex: 1, paddingRight: "30px" }}>
                          <h5 style={{ margin: "0 0 10px", fontWeight: "bold" }}>
                            {item.number}. {item.title}
                          </h5>
                          <p style={{ margin: 0 }}>{item.topics}</p>
                        </div>
                        <div
                          className="course-detail-video"
                          style={{ position: "relative", minWidth: "120px", marginLeft: "20px" }}
                        >
                          <a
                            href={item.youtubeShort}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ display: "block", position: "relative" }}
                          >
                            <img
                              src={thumbnailUrl}
                              alt={`Youtube Short for ${item.title}`}
                              style={{ width: "150px", height: "auto", borderRadius: "4px" }}
                            />
                            <div
                              className="play-button"
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: 2,
                              }}
                            >
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="#fff"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <polygon points="12,8 24,16 12,24" />
                              </svg>
                            </div>
                          </a>
                        </div>
                      </li>
                    );
                  })}
                </ul>

                {/* <h3>
                  <span>Course Details</span>
                </h3> */}

                {/* <ul className="course-details-list">
                  <li>

                      {" "}
                      <b>1. Introduction to CML- </b>{" "}

                    Overview, CML Versus CDSW, ML Workspaces,
                    Workspace Roles, Projects and Teams, Settings,
                    Runtimes/Legacy Engines.
                  </li>

                  <li>

                      {" "}
                      <b>2. Introduction to AMPs and the Workbench -</b>{" "}

                     Editors and IDE, Git, Embedded Web
                    Applications, AMPs, Data Access and Lineage.
                  </li>

                  <li>

                      {" "}
                      <b> 3. SDX Overview -</b>{" "}

                   Data Catalog, Authorization, Lineage.
                  </li>

                  <li>

                      {" "}
                      <b> 4. Data Visualization in CML -</b>{" "}

                     Data Visualization Overview, CDP Data
                    Visualization Concepts, Using Data Visualization in CML.
                  </li>

                  <li>

                      {" "}
                      <b> 5. Experiments -</b>{" "}

                     Experiments in CML, Introduction to the
                    CML Native Workbench.
                  </li>

                  <li>

                      {" "}
                      <b>6. Spark Overview -</b>{" "}

                     How Spark Works, The Spark Stack, File
                    Formats in Spark, Spark Interface Languages, Introduction to
                    PySpark, How Data Frame Operations Become Spark Jobs, How
                    Spark Executes a Job.
                  </li>

                  <li>

                      <b> 7. Running a Spark Application -</b>{" "}

                     Running a Spark Application, Reading data
                    into a Spark SQL Data Frame, Examining the Schema of a Data
                    Frame, Computing the Number of Rows and Columns of a Data
                    Frame, Examining a Few Rows of a Data Frame, Stopping a
                    Spark Application.
                  </li>

                  <li>

                      {" "}
                      <b>8. Inspecting a Spark Data Frame -</b>{" "}
                    Inspecting a Data Frame, Inspecting a Data
                    Frame Column.
                  </li>

                  <li>

                      <b> 9. Transforming Data Frames -</b>{" "}
                   Spark SQL Data Frames, Working with
                    Columns, Working with Rows, Working with Missing Values,
                    Transforming Data Frame Columns.
                  </li>

                  <li>

                      <b>10. Spark SQL Data Types -</b>{" "}
                    Working with Numerical Columns, Working
                    with String Columns, Working with Date and Timestamp
                    Columns, Working with Boolean Columns, Complex Types.
                  </li>

                  <li>

                      <b>11. User-Defined Functions -</b>{" "}
                  Example 1: Hour of Day, Example 2:
                    Great-Circle Distance.
                  </li>

                  <li>

                      <b>12. Reading and Writing Data Frames -</b>{" "}
                     Working with Delimited Text Files, Working
                    with Text Files, Working with Parquet Files, Working with
                    Hive Tables, Working with Object Stores, Working with Pandas
                    Data Frames.
                  </li>

                  <li>

                      <b> 13. Combining and Splitting Data Frames -</b>{" "}
                    Joining Data Frames, Splitting a Data
                    Frame.
                  </li>

                  <li>

                      <b> 14. Summarizing and Grouping Data Frames -</b>{" "}
                     Summarizing Data with Aggregate Functions,
                    Grouping Data, Pivoting Data.
                  </li>

                  <li>
                 
                      {" "}
                      <b> 15. Window Functions -</b>{" "}
               Example: Cumulative Count and Sum,
                    Example: Compute Average Days Between Rides for Each Rider.
                  </li>

                  <li>

                      <b> 16. Machine Learning Overview -</b>{" "}
                   Introduction to Machine Learning, Machine
                    Learning Tools, Apache Spark MLlib.
                  </li>

                  <li>

                      <b> 17. Exploring and Visualizing Data Frames -</b>{" "}
                  Possible Workflows for Big Data, Exploring
                    a Single Variable, Exploring a Pair of Variables.
                  </li>

                  <li>

                      <b>
                        {" "}
                        18. Monitoring, Tuning, and Configuring Spark
                        Applications -
                      </b>{" "}
                    Monitoring Spark Applications, Configuring
                    the Spark Environment.
                  </li>

                  <li>

                      <b> 19. Fitting and Evaluating Regression Models -</b>{" "}
                   Assemble the Feature Vector, Fit the
                    Linear Regression Model.
                  </li>

                  <li>

                      <b>
                        {" "}
                        20. Fitting and Evaluating Classification Models -{" "}
                      </b>{" "}

                    Generate Label, Fit the Logistic
                    Regression Model.
                  </li>

                  <li>

                      <b>
                        {" "}
                        21. Tuning Algorithm Hyperparameters Using Grid Search -{" "}
                      </b>{" "}

                   Requirements for Hyperparameter Tuning,
                    Tune the Hyperparameters Using Holdout Cross-Validation,
                    Tune the Hyperparameters Using K-Fold Cross-Validation.
                  </li>

                  <li>

                      <b> 22. Fitting and Evaluating Clustering Models -</b>{" "}
 Print and Plot the Home Coordinates, Fit a
                    Gaussian Mixture Model, Explore the Cluster Profiles.
                  </li>

                  <li>

                      <b>
                        {" "}
                        23. Processing Text: Fitting and Evaluating Topic Models -{" "}
                      </b>{" "}
                   Fit a Topic Model Using Latent Dirichlet
                    Allocation.
                  </li>

                  <li>

                      <b> 24. Fitting and Evaluating Recommender Models -</b>{" "}
                   Recommender Models, Generate
                    Recommendations.
                  </li>

                  <li>

                      <b> 25. Working with Machine Learning Pipelines - </b>{" "}
                 Fit the Pipeline Model, Inspect the
                    Pipeline Model.
                  </li>

                  <li>

                      <b>
                        {" "}
                        26. Applying a Scikit-Learn Model to a Spark Data Frame -{" "}
                      </b>{" "}
                     Build a Scikit-Learn Model, Apply the
                    Model Using a Spark UDF.
                  </li>

                  <li>

                      <b>
                        {" "}
                        27. Deploying a Machine Learning Model as a REST API in
                        CML -{" "}
                      </b>{" "}
                    Load the Serialized Model, Define a
                    Wrapper Function to Generate a Prediction, Test the
                    Function.
                  </li>

                  <li>

                      <b>
                        {" "}
                        28. Auto scaling, Performance, and GPU Settings -{" "}
                      </b>{" "}

                    Auto scaling Workloads, Working with GPUs.
                  </li>

                  <li>

                      <b> 29. Model Metrics and Monitoring -</b>{" "}
                    Why Monitor Models?, Common Models
                    Metrics, Models Monitoring With Evidently, Continuous Model
                    Monitoring.
                  </li>

                  <li>

                      <b>30. Appendix: Workspace Provisioning -</b>{" "}
                    Workspace and Environment.
                  </li>
                </ul> */}
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 col-md-12">
              <div className="service__details__left">
                    <iframe
                      width="100%"
                      height="600"
                      src={featuredEmbedUrl}
                      title="Featured YouTube Video"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{ borderRadius: "8px" }}
                    ></iframe>
                <div className="sidebar__widget">
                  <div className="all__service">
                    <h4>All Courses</h4>
                  </div>

                  <ul className="service__details__1__cat">
                    {renderServices()}
                  </ul>
                </div>

                {/* <div
                  className="sidebar__widget_network"
                  style={{ backgroundImage: `url(${basebg})` }}
                >
                  <h3>Contact Us For Any Require</h3>

                  <div className="services__icon">
                    <i className="icon-19"></i>
                  </div>

                  <p>Need help? Call us:</p>

                  <h4>+65 90059743</h4>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default MachineLearning;
